import React from "react";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";
import { Button } from "react-bootstrap";
import _ from "lodash";
import { Player, ControlBar, PlayToggle, BigPlayButton, VolumeMenuButton, ProgressControl, CurrentTimeDisplay, TimeDivider, DurationDisplay/*, FullscreenToggle*/ } from "video-react";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";

import { isIphone } from "../../utils/browserUtils";
import { showVideoPreview } from "../../actions/playerActions";
import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";

// import "../node_modules/video-react/dist/video-react.css";
// import "./Video.css";


/*
	Video player component for items
*/
class PlayerItemVideo extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);

		this.state = {
			playsInline: true
		};
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.hasOwnProperty("showMode") || !nextProps.showMode) {
			if (this.props.selected === false && nextProps.selected === true) {
			
				this.handlePlayVideo();
			} else if (this.props.selected === true && nextProps.selected === false) {
				this.handleStopVideo();
			}	
		}
	}

	
	handlePlayVideo() {
		let video = _.get(this.props.videoRef, "current.video");

		if (video) {
			setTimeout(() => {
				video.muted = true;
				video.seek(0);
				video.play();
			}, 250);
		}
	}

	handleStopVideo() {
		let video = _.get(this.props.videoRef, "current.video");

		if (video) {
			video.pause();
		}
	}

	componentDidMount() {
		// if (isIphone()) {
		// 	//listen for native player close
		// 	this.props.videoRef.current.video.video.addEventListener("webkitendfullscreen", this.handleCloseIosNativeFullscreen);
		// 	this.props.videoRef.current.video.video.addEventListener("click", this.handleVideoOnClick);
		// }
		if (this.props.autoPlay) {
			this.handlePlayVideo();
		}
	}

	componentWillUnmount() { 
		// if (isIphone()) {			
		// 	this.props.videoRef.current.video.video.removeEventListener("webkitendfullscreen", this.handleCloseIosNativeFullscreen);
		// 	this.props.videoRef.current.video.video.removeEventListener("click", this.handleVideoOnClick);
		// }
	}

	// handleVideoOnClick() {
	// 	this.handlePlayFullscreen();
	// }

	handleCloseIosNativeFullscreen() {
		this.setState({
			playsInline: true
		});
}	

	handlePlayFullscreen(video) {
		SyntheticVoiceApi.stop();

		showVideoPreview(this.context.tree,video);

		// if (ref && ref.current) {
			
		// 	ref.current.pause();
		// 	ref.current.seek(0);			

		// 	if (isIphone()) {
		// 		this.setState({
		// 			playsInline: false
		// 		});

		// 		setTimeout(() => {
		// 			ref.current.muted = false;
		// 			ref.current.play();
		// 		});				
		// 	} else {
		// 		ref.current.toggleFullscreen();
		// 		ref.current.muted = false;
		// 		ref.current.play();				
				
		// 	}			
		// }
	}
	


	render() {
		let { videoRef, url, playerMuted, autoPlay, loop } = this.props;	
		const { videoPlayEngaged } = this.state;

		if (autoPlay && !videoPlayEngaged) {
			this.handlePlayVideo();
		}

		const showMode = (this.props.hasOwnProperty("showMode") && this.props.showMode) ? true : false; 

		let controls = /*(!isIphone()) ?
			<ControlBar disableDefaultControls={true}>
				<PlayToggle />
				<VolumeMenuButton />
				<CurrentTimeDisplay />
				<TimeDivider />
				<DurationDisplay />
				<ProgressControl />
			</ControlBar> :*/ <ControlBar disableCompletely={true} />;

		let component = <div className={showMode?"my-video-react-video-show-mode":"my-video-react-video"} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent:"conter", width: "100%", height: showMode?"90%":"100%" }}>
			<Player
				width="100%"
				height="100%"
				playsInline={true}
				src={url}
				aspectRatio={this.props.aspectRatio}
				// autoPlay={showMode ? false : autoPlay}
				muted={showMode ? false : playerMuted}
				ref={videoRef}
				fluid={false}
				onLoadStart={() => {}}
				onError = {()=>{
					const { listIndex, sectionIndex, itemIndex } = this.props;

					const pos = listIndex + "," + sectionIndex + "," + itemIndex;
		
					global.loadedVideosHash[pos] = "error";		
				}}
				onCanPlay={()=>{
					const { listIndex, sectionIndex, itemIndex } = this.props;

					const pos = listIndex + "," + sectionIndex + "," + itemIndex;
		
					global.loadedVideosHash[pos] = "loaded";
				}}
				loop={loop}>
				
				<BigPlayButton position="center" />
				{controls}
			</Player>
			{/* !webMode && <Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesomeIcon icon="external-link" /> View In New Tab</Button> */}
			{((!this.props.hasOwnProperty("showFullscreenToggle") || this.props.showFullscreenToggle) && (_.isString(url) && url !== "")) &&
				<div style={{ flex: 0, display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
				<Button onClick={(e) => {e.stopPropagation(); this.handlePlayFullscreen(url);}}><FontAwesomeIcon icon="arrows-alt" /> View Fullscreen</Button>
			</div>
		}
		</div>;

		return component;
	}

}


PlayerItemVideo.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
}, PlayerItemVideo);